var map = {
	"./PRNreferencehint.png": 6663,
	"./V5Creferencehint.png": 9037,
	"./VRMreferencehint.png": 8168,
	"./card-types.png": 3741,
	"./icon-tick-green.gif": 1097,
	"./loading-buffering.gif": 8425,
	"./mastercard.png": 3971,
	"./visa.png": 2576
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6190;